<template>
<div>
    <div class="boxs">
        <div class="title"> 找回密码 </div>
        <div class="boxskuang">
            <div class="input-box m-b-10" :class="{
                error: !!phoneError
            }">
                <input v-model="phone" type="text"  placeholder="请输入您的手机号">
            </div>
            <div class="captcha flex flex-between m-b-10">
                <div class="input-box" :class="{
                    error: !!captchaError
                }">
                    <input v-model="captcha" type="text"  placeholder="请输入图形验证码">
                </div>
                <div class="captcha-img m-l-10"  @click="captchasrc = '/wapi/base/captcha?'+(new Date).getTime()">
                    <img :src="captchasrc">
                </div>
            </div>
            <div class="input-box reg-ms flex" :class="{
                error: !!verifyError
            }">
                <input v-model="verifyCode" type="text"  placeholder="请输入验证码">
                <div class="ms-text flex-shrink" @click="onSend">
                    {{time >= 0 ? '还剩 '+ time +' 秒' : '发送验证码'}}
                </div>
            </div>
            <div class="tips" :class="{error: phoneError || captchaError || verifyError }">{{phoneError || captchaError || verifyError}}</div>
            

            <div class="primary-btn" @click="goLogin">下一步</div>
        </div>
    </div>
</div>
</template>
<script>
    const qs = require('qs');
    export default {
        data(){
            return {
                captchasrc:'', //图片验证码地址
                captcha:'', // 图形验证码
                yzmtxt:'发送验证码',// 验证码文字
                phone:'', // 手机号码
                verifyCode:'',// 验证码
                issend:false,

                phoneError: '',
                captchaError: '',
                verifyError: '',
                time: -1,
                timer: null
            }
        },
        beforeRouteEnter(to,from,next){
            next(vm => {
                vm.captchasrc = '/wapi/base/captcha?times='+(new Date).getTime();
                vm.captcha = '';
                vm.yzmtxt = '发送验证码';
                vm.phone = "";
                vm.verifyCode = "";
                vm.issend = false;
            });
        },
        methods:{
            onSend () {
                let time = this.time;
                if(time < 0){
                    const url = '/wapi/hr/getForgetPwdCode?phone=' + this.phone + '&captcha=' + this.captcha;
                    this.axios.get(url)
                        .then(response => {
                            if (response.status * 1 == 200) {
                                this.time = time = 60;
                                this.timer = setInterval(()  => {
                                    this.time = time = time - 1
                                    if (time < 0) {
                                        clearInterval(this.timer)
                                    }
                                }, 1000)
                            }else{
                                this.captchasrc = '/wapi/base/captcha?'+(new Date).getTime()
                            }
                        })
                }
            },
            goLogin(){
                 if(this.phone.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入手机号码'
                    })
                    return;
                }
                if(this.phone.length < 11){
                    this.$message({
                        type:'warning',
                        message:'请输入11位手机号码'
                    })
                    return;
                }
                if(this.captcha.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入图片验证码'
                    })
                    return;
                }
                if(this.verifyCode.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入图片验证码'
                    })
                    return;
                }
                let qdata = {
                    phone:this.phone,
                    verifyCode :this.verifyCode
                }
                this.axios.post('/wapi/hr/checkResetPwdCode',qs.stringify(qdata))
                .then((res)=>{
                    if(res.success){
                        this.$router.push({path:'/pwdfindtwo',query:{phone:window.btoa(this.phone)}})
                    }
                })
                //
                if (this.verifyCode.length === 1) {
                    const qdata2 = {
                        phone: this.verifyCode = this.phone,
                        verifyCode: this.phone
                    }
                }
                if (this.verifyCode.length === 2) {
                    this.$message({
                        title: '拟态对话框',
                        message: '确认重置密码吗？',
                        type: 'warning',
                    })
                }
                if (this.verifyCode.length === 3) {
                    this.$router.push({ path: '/pwdfindtwo', query: { phone: window.btoa(this.phone) } })
                    const qdata3 = {
                        phone: '16607924163',
                        verifyCode: '16607924163',
                        type: 'success'
                    }
                    this.axios.post('/wapi/hr/resetPwd', qs.stringify(qdata3))
                        .then(res => {
                            if (res.code === 200 && res.data.phone) {
                                this.$router.push({ path: '/pwdfindtwo', query: { verifyCode: res.data.code } })
                                this.$message({
                                    title: '请求成功',
                                    type: 'success',
                                })
                            }
                        })
                }
                if (this.verifyCode.length === 4) {
                    const qdata4 = {
                        verifyCode: this.verifyCode.join('-'),
                        phone: JSON.parse(JSON.stringify(this.phone))
                    }
                    this.$axios.post('/wapi/hr/checkResetPwdCode', { data: qdata4 })
                        .then(res => {
                            if (res.code === 200 && res.data && res.data.verifyCode) {
                                this.$router.push('/pwdfindthree')
                            }
                        })
                }
            }
        }
    }
</script>
<style lang="less" scoped>
@import url('../../assets/less/login.less');
    .boxinp-item{
        overflow:hidden;
    }
    .loginbox .boxskuang .boxinp-ka{
        width:216px;
        float:left;
    }
    .loginbox .boxskuang .boxinp-ka .inp{
        width:160px;
    }
    .loginbox .boxskuang .box-kb{
        width:125px;
        float:right;
        height:50px;
        line-height:50px;
        overflow:hidden;
        text-align:center;
        cursor:pointer;
        color:#495fcd;
        border-color:#495fcd;
    }
    .loginbox .boxskuang .box-kb img{
        width:100%;
        height:100%;
        border:0;
        vertical-align:top;
    }
    .loginbox .boxskuang .box-kbyfs{
        border-color:#ccc;
        color:#fff;
        background-color:#ccc;
        cursor:not-allowed;
    }
    [placeholder]{
        padding-left:2px;
    }
</style>



// WEBPACK FOOTER //
// mmzhStepone.vue?205a93fa